import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { sessionState } from '@chainlit/react-client';

import { reportFormState, ReportFormPayload } from '@/state/project';

export default function ReportFormListener() {
  const session = useRecoilValue(sessionState);
  const setPayload = useSetRecoilState(reportFormState);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: ReportFormPayload) => {
      setPayload(payload);
    };
    const dismissHandler = () => {
      setPayload(null);
    };
    socket.on('ask_report_form', handler);
    socket.on('dismiss_report_form', dismissHandler);
    return () => {
      socket.off('ask_report_form', handler);
      socket.off('dismiss_report_form', dismissHandler);
    };
  }, [session?.socket, setPayload]);

  return null;
}
